import React from 'react';
import CloseSVG from '../../image/icons/calendar/Close.svg';

interface ModalProps {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: (value: boolean) => void;
}

const Modal: React.FC<ModalProps> = ({ children, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-gray-400 bg-opacity-40 z-50"
      onClick={() => { onClose(false); }}
    >
      <div
        className="bg-white rounded-xl p-6 relative w-4/5 lg:w-2/6"
        onClick={(e) => { e.stopPropagation(); }} // Prevent clicks from bubbling up
      >
        <button
          className="absolute top-3 right-3"
          onClick={() => {
            onClose(false);
          }}
        >
          <img src={CloseSVG} alt="Close" />
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
